import Vue from 'vue'

let swalPromise = null

function loadSwal() {
  if (!swalPromise) {
    swalPromise = Promise.all([
      import('sweetalert2'),
      import('sweetalert2/dist/sweetalert2.min.css'),
    ]).then(([mod]) => mod.default || mod)
  }
  return swalPromise
}

async function swalFire(options) {
  const Swal = await loadSwal()
  return Swal.fire(options)
}

export default () => {
  Vue.prototype.$swal = swalFire

  Vue.prototype.$swalError = function (error) {
    return swalFire({
      title: this.$t('plugins.swalError.title'),
      text: error?.response
        ? this.$t('plugins.swalError.text') + ' : ' + error.response.status
        : this.$t('plugins.swalError.network'),
      icon: 'error',
    })
  }

  Vue.prototype.$swalErrorMessage = function (error) {
    const response = error?.response
    let errors = ''

    if (!response) {
      errors = error?.isAxiosError
        ? this.$t('plugins.swalError.network')
        : error?.message
    } else if (response.status === 429) {
      errors = this.$t('plugins.swalError.tooManyRequests')
    } else if (response.data?.errors) {
      for (const [key, value] of Object.entries(response.data.errors)) {
        value.forEach(errorMessage => {
          if (key == 'phone') {
            errors += '- ' + this.$t('plugins.swalError.phone') + '<br />'
          } else if (errorMessage != 'undefined') {
            errors += '- ' + errorMessage + '<br />'
          }
        })
      }
    } else if (response.data?.message) {
      errors = response.data.message
    } else {
      errors = error.message
    }

    return swalFire({
      title: this.$t('plugins.swalError.title'),
      html: errors,
      icon: 'error',
    })
  }

  Vue.prototype.$swalErrorCustomMessage = function (customErrorMessage) {
    return swalFire({
      title: this.$t('plugins.swalError.title'),
      text: customErrorMessage,
      icon: 'error',
    })
  }

  Vue.prototype.$swalInfoCustomMessage = function (title, message) {
    return swalFire({
      title: title,
      html: message,
      icon: 'info',
    })
  }

  Vue.prototype.$swalCustomSuccess = function (title, message) {
    return swalFire({
      title: title,
      text: message,
      icon: 'success',
    })
  }
  Vue.prototype.$swalUpdateSuccess = function () {
    return swalFire({
      title: this.$t('plugins.swalUpdateSuccess.title'),
      text: this.$t('plugins.swalUpdateSuccess.text'),
      icon: 'success',
    })
  }
  Vue.prototype.$swalCreateSuccess = function () {
    return swalFire({
      title: this.$t('plugins.swalCreateSuccess.title'),
      text: this.$t('plugins.swalCreateSuccess.text'),
      icon: 'success',
    })
  }

  Vue.prototype.$swalCustomValidation = function (title) {
    return new Promise(resolve => {
      swalFire({
        title: title,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
      }).then(result => {
        if (result.value) {
          resolve()
        }
      })
    })
  }

  Vue.prototype.$swalDeleteValidation = function () {
    return new Promise(resolve => {
      swalFire({
        title: this.$t('plugins.swalDeleteValidation.title'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t(
          'plugins.swalDeleteValidation.confirmButtonText'
        ),
        cancelButtonText: this.$t(
          'plugins.swalDeleteValidation.cancelButtonText'
        ),
      }).then(result => {
        if (result.value) {
          resolve()
        }
      })
    })
  }
  Vue.prototype.$swalDuplicateValidation = function () {
    return new Promise(resolve => {
      swalFire({
        title: this.$t('plugins.swalDuplicationValidation.title'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t(
          'plugins.swalDuplicationValidation.confirmButtonText'
        ),
        cancelButtonText: this.$t(
          'plugins.swalDuplicationValidation.cancelButtonText'
        ),
      }).then(result => {
        if (result.value) {
          resolve()
        }
      })
    })
  }

  Vue.prototype.$swalDeleteSuccess = function () {
    return swalFire({
      title: this.$t('plugins.swalDeleteSuccess.title'),
      text: this.$t('plugins.swalDeleteSuccess.text'),
      icon: 'success',
    })
  }
}
